import {message} from "antd";
import axios from '../../axios/axios_authorization'
import * as qs from "qs";
import * as config from "../config/config";
import Cookies from "js-cookie";
import swal from "sweetalert";
import success_icon from "../../assets/img/sweet/success.svg";
import error_icon from "../../assets/img/sweet/cry.svg";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import apiConfig from "../../axios/axios_api_services";
import * as keys from "../key/Key";
import * as routeConstants from "../route/Route";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/20/19
 * Time: 10:21 AM
 */

export const COMMING_SOON_TEXT = "We are currently working on this feature and will launch soon";
export const ALREADY_REGISTERED_USER = "Sorry, you've already registered for this event";
export const ADMIN_NOT_APPROVED_REQUEST = "Admin has not yet approved your registration request for this event";
export const ALREADY_CHECKED_IN_USER = "You've already checked-in for this event";
export const ADMIN_REQUEST_REJECT = "Your request to register for this event is rejected by the admin. Please contact your event administrator for assistance.";

export const notifyMessage = (msg, type, duration) => {
  let msgType = "error";
  if (type === 0) {
    msgType = "error"
  } else if (type === 1) {
    msgType = "warning"
  } else if (type === 2) {
    msgType = "success"
  }

  message[msgType](msg === undefined || msg === null ? "Please enter correct details" : msg, duration === undefined ? 2 : duration)
};

export const warningAlert = (msg, type, className) => {
  swal({
    className: className? className:'',
    title: msg,
    icon: type === 0 ? success_icon : error_icon,
    closeOnClickOutside: false,
    buttons: {
      dangerMode: {
        text: "Okay",
        value: "action",
        className: "okay-btn"
      }
    }
  })
    .then((value) => {
      switch (value) {

        case "action":
          break;
        default:
      }
    })
};

export const convertDate = (date) => {
  let d = new Date(date);
  d = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
  return d;
};

export async function renewToken(userRole) {
  let promise = 0;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    "Authorization": "Basic " + config.CLIENT_SECRET
  };
  let refresh_token = Cookies.get('9b8558ba3f051677daf36ebfc67f29fa');

  const data_ = {
    grant_type: "refresh_token",
    refresh_token: refresh_token
  };

  // Get Access token from refresh token
  await axios.post(apiConfig.OAUTH, qs.stringify(data_), {headers: headers})
    .then(async response => {
      Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token); //access-token (68a6102f6ed24899420170004a0273b8)
      promise = await 1;

    })
    .catch(error => {
      // if response status code 401, redirect login page
      swal({
        title: "Your token expired! Please re-enter login credentials \n Thank you",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          // cancel: 'Cancel',
          dangerMode: {
            text: "Okay",
            value: "action",
            className: "warning-btn"
          }
        },
      })
        .then((value) => {
          switch (value) {

            case "action":
              Cookies.remove(keys.ACCESS_TOKEN);
              Cookies.remove(keys.REFRESH_TOKEN);

              if(userRole === keys.GUEST_USER_USER_ROLE){
                localStorage.removeItem(keys.GUEST_CACHE);
                window.location.href = `${routeConstants.GUEST_ROUTE_PATH}/login`;
              }else{
                window.location.href = "/";
              }

              break;
            default:
          }
        });
    });

  return promise;
}


export async function checkErrorResponse(error,user_role) {
  let promise;
  if (error !== undefined) {
    if (error.response === undefined) {
      notifyMessage("Your connection was interrupted!", 1, 3);
      promise = await 0;
    } else if (error.response.status === 401) {
      promise = await renewToken(user_role);
    } else if (error.response.status === 403) {
      notifyMessage("Access is denied.", 1, 3);
      promise = await 0;
    } else if (error.response.status === 417) {
      notifyMessage("Oops! Something went wrong.", 1, 3);
      promise = await 0;
    } else {
      notifyMessage("Sorry, something went wrong.", 1, 3);
      promise = await 0;
    }
  } else {
    notifyMessage("Your connection was interrupted!", 1, 3);
    promise = await 0;
  }
  return promise;
}

export const getB64ToBlob = (b64Data, contentType='image/png') => {
  const byteCharacters = atob(b64Data.substr(`data:${contentType};base64,`.length));
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, {type: contentType});
  return URL.createObjectURL(blob);
};
export const random5DigitNumGenarator = () => {
  return Math.floor(Math.random()*90000) + 10000;
};
export const getRandomColor = () => {
  let letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
export function isProduction () {
  return window.location.origin.indexOf('https://tags.lk') !== -1 || window.location.origin.indexOf("https://tags.dialog.lk") !== -1;
}
